import { Injectable } from "@angular/core";
import { Email } from "@barthauer/custom/xmt-models";
import { Observable } from "rxjs";
import { DataService } from "./data.service";

@Injectable({ providedIn: "root" })
export class EmailService {
    private readonly sendEmailWebApi: string;
    private readonly sendAnonymousEmailWebApi: string;

    constructor(private dataService: DataService) {
        this.sendEmailWebApi = this.dataService.currentCongfiguration.WebApi.ServiceURLs.SendEmail;
        this.sendAnonymousEmailWebApi = this.dataService.currentCongfiguration.WebApi.ServiceURLs.SendAnonymousEmail;
    }

    public sendEmail(email: Email, isAnonymous = false): Observable<ArrayBuffer> {
        return this.dataService.coreDataService.executeWebApiPOSTMethod(
            isAnonymous ? this.sendAnonymousEmailWebApi : this.sendEmailWebApi,
            email
        );
    }

    public prepareEmailBody(template: string, data: unknown): string {
        const htmlContent = template.replace(/{{\s*([\w.]+)\s*}}/g, (_, key) => {
            return key.split(".").reduce((acc, part) => acc?.[part], data) ?? "";
        });
        return htmlContent;
    }
}
